import React, { useState, useMemo, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Button } from '@ui/atoms/Button/Button';
import CompleteReviewModal from '@features/AiToReviewInspectionsIndex/components/CompleteReviewModal';
function CompleteReviewButton({ inspectionId, currentStatus, buttonText, iimReviewStatus, isVisible }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [buttonVisible, setButtonVisible] = useState(isVisible);
    const queryClient = useMemo(() => new QueryClient(), []);
    const handleButtonClick = () => {
        setIsModalOpen(true);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {
        // listen to custom events from jQuery for tab changes
        const handleTabVisibilityChange = (event) => {
            var _a, _b;
            setButtonVisible((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.isVisible) !== null && _b !== void 0 ? _b : true);
        };
        // add listener to the custom event
        document.addEventListener('tabVisibilityChange', handleTabVisibilityChange);
        // Check active tab state on mount in case the jQuery event fired before React mounted
        const activeTab = document.querySelector('.workspace__tabs .active a');
        if (activeTab) {
            setButtonVisible(activeTab.getAttribute('href') === '#iim-issues');
        }
        return () => {
            document.removeEventListener('tabVisibilityChange', handleTabVisibilityChange);
        };
    }, []);
    if (!buttonVisible || iimReviewStatus === 'iim_completed') {
        return null;
    }
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(Button, { variant: "primary", onClick: handleButtonClick }, buttonText),
        React.createElement(CompleteReviewModal, { isOpen: isModalOpen, inspectionId: String(inspectionId), currentStatus: currentStatus, onClose: handleModalClose })));
}
export default CompleteReviewButton;
